import RibbonButton, { RibbonButtonState } from './RibbonButton';
import updateCachedFormatViewState from '../../actions/updateCachedFormatViewState';
import strings from 'owa-strings/owa-mail-strings';
import { getFormatState } from 'roosterjs-editor-api';

const formatPainter: RibbonButton = {
    key: 'formatPainter',
    title: () => strings.formatPainter,
    imageSrc: require('../svg/formatpainter.svg'),
    buttonState: formatState =>
        formatState.formatPainterFormat ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => {
        let format = plugin.getFormatState();
        updateCachedFormatViewState(
            format,
            format.formatPainterFormat ? null : getFormatState(plugin.getEditor())
        );
    },
};

export default formatPainter;
